import styled from 'styled-components';
import { motion, AnimatePresence } from 'motion/react';
import { getorientation } from '~/utils/style-utils.ts';

const springSettings = { type: 'spring', stiffness: 300, damping: 200 };
const variants = {
	enter: {
		transform: `translate3d(0%, 0%, 0)`,
		height: '100%',
		opacity: 1
	},
	exit: { transform: `translate3d(0%, 100%, 0)`, opacity: 0 }
};

const ModalContainer = styled(motion.div)`
	height: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	top: 0;
`;
const ModalContent = styled.div`
	top: 140px;
	overflow: hidden;
	position: relative;
	border-radius: 7px;
	height: calc(100% - 140px);
	background: #ffff;
	width: auto;
	margin: 0 auto;
	${getorientation.landscape`
			 top:60px;
			 height:calc(100% - 60px);
			 width: calc(100% - 300px);
			 min-width: 360px;
	`}
`;

const QuickDepositModal = ({ children }) => {
	return (
		<AnimatePresence>
			<ModalContainer
				variants={variants}
				animate="enter"
				initial="exit"
				exit="exit"
				key="slideUp"
				transition={{
					transform: { springSettings },
					opacity: { springSettings }
				}}
			>
				<ModalContent title="model-content">{children}</ModalContent>
			</ModalContainer>
		</AnimatePresence>
	);
};

export default QuickDepositModal;
